<template>
  <div class="configItemDetail">
    <div style="text-align: left; padding: 7px 0 20px 0;">
      <el-button size="mini" @click="goback">Return</el-button>
      <el-button type="primary" size="mini" @click="openEditConfig">Add</el-button>
    </div>
    <div class="contentTableDiv">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" >
        <el-table-column prop="id" v-if="false"></el-table-column>
        <el-table-column prop="label" label="Label Key" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="value" label="Label Value" align="center"></el-table-column>
        <el-table-column label="Operation" align="center" fixed="right"  width="300">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openEditConfig(scope.row)">Edit</el-button>
            <el-button size="mini" type="danger" @click="deleteConfig(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
    </el-table> 
    </div>
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize"
        layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <!--修改--> 
    <el-dialog :visible.sync="editConfigModal" :destroy-on-close="true" class="configDialog" :close-on-click-modal="false" width="500px" :title="editConfigForm && editConfigForm.id ? 'Edit Label' : 'Add Label'">
      <div slot="footer">
        <el-button size="small" @click="closeModal">Cancel</el-button>
        <el-button type="primary" size="small" @click="confirmConfig" :loading="confirmLoading">Confirm</el-button>
      </div>
      <el-form :model="editConfigForm" ref="editConfigForm" label-width="130px" class="configItemDetail">
        <el-form-item label="Label Key:" prop="label" :rules="{ required: true, message: 'Please input' }">
          <el-input v-model="editConfigForm.label" clearable size="small" placeholder="Please input" />
        </el-form-item>
        <el-form-item label="Label Value:" prop="value" :rules="{ required: true, message: 'Please input' }">
          <el-input v-model="editConfigForm.value" clearable size="small" placeholder="Please input" />
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<style>
  
</style>
<script>
  export default {
    name: 'detailList',
    props: {
			configMainId: {
        type: Number,
        default: null,
      },
		},
    created () {
      this.getConfigDetailList();
    },
    data () {
      return {
        editConfigModal: false,
        editConfigForm: {},
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
        tableData: [],
        confirmLoading: false,
        detailModal: false,
      }
    },
    methods: {
      goback() {
				this.$emit('closeDetail');
      },
      getConfigDetailList() {
        let url = `${this.$store.state.islhurl}configDetail/getListByPage/${this.pageSize}/${this.currentPage}`
        let pm = {
          islhToken: sessionStorage.getItem('islhtoken'),
          configMainId: this.configMainId,
        }
        this._post(url,pm).then(
          res =>{
            if(res.code == 200) {
              this.tableData = res.data
              this.totalCount = res.totalNums
            }
          }
        )
      },
      openEditConfig(row) {
        this.editConfigModal = true;
        if(row && row.id) {
          this.editConfigForm = {
            ...row
          };
        }
      },
      deleteConfig(row) {
        this.$confirm("Are you sure to delete", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          let url = `${this.$store.state.islhurl}configDetail/delete?id=${row.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`
          this._post(url).then(
            res =>{
              if(res.code === 200) {
                this.getConfigDetailList();
                this.$Message.success('Delete Successful' )
              } else {
                this.$message({
                  type:'error',
                  message: res
                });
              }
            }
          )
        }).catch(() => {
        });
      },
      closeModal() {
        this.editConfigModal = false;
        this.editConfigForm = {};
      },
      confirmConfig() {
        this.$refs.editConfigForm.validate((valid) => {
          if (valid) {
            let url = `${this.$store.state.islhurl}configDetail/edit`
            if(this.editConfigForm.id == null) {
              url = `${this.$store.state.islhurl}configDetail/add`
            }
            let pm = {
              ...this.editConfigForm, 
              configMainId: this.configMainId,
              islhToken: sessionStorage.getItem('islhtoken')
            }
            this.confirmLoading = true;
            this._post(url,pm).then(
              res =>{
                if(res.code === 200) {
									this.$Message.success('Successful!' );
									this.getConfigDetailList();
                  this.closeModal();
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
								this.confirmLoading = false;
              }
            )
          }
        });
      },
      changePage (val) {
        this.currentPage = val
        this.getConfigDetailList();
      },
      changePageSize (val) {
        this.pageSize = val
        this.getConfigDetailList();
      },
      openDetail(row) {
        this.detailModal = true;
        this.detailInfo = row;
      },
    }
  }
</script>
<style lang="less" scoped>
.configItemDetail {
  padding: 0 15px;
	.el-form {
		padding: 20px 0 0 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
		/deep/.el-select {
			width: 100%;
		}
	}
}
.configDialog {
  /deep/.el-dialog__body {
    padding: 0 20px;
    .el-form-item {
      padding-bottom: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sysdata/configurationItem/detailList.vue